import { Component, OnInit } from '@angular/core';
import { MantenedorService } from 'src/app/services/mantenedor.service';
import { URL_DOCS } from 'src/app/config/config';
import Swal from 'sweetalert2';

declare var $: any;

@Component({
  selector: 'app-admin-mantenedores',
  templateUrl: './admin-b2b-agreement.component.html',
  styleUrls: ['./admin-b2b-agreement.component.css']
})
export class AdminB2BAgreementComponent implements OnInit {

  public b2bAgreementList: any = [];
  public b2bAgreementSelected: any = [];
  
  public nuevoB2BAgreement: any = {};

  public b2bAgreementTypeList: any = [];
  public b2bAgreementTypeSelected: any = [];


  URL_DOCS = URL_DOCS;
  isEdit = false;
  isLoading = false;
  isSubmitting = false;

  selectedImageFile: File | null = null;
  imagePreview: string | ArrayBuffer | null = null;
  imageError: string | null = null;

  constructor(
    public mantenedorService: MantenedorService,
  ) {}

  ngOnInit(): void {
    this.getB2BAgreement();
  }

  getB2BAgreement() {
    this.isLoading = true;
    this.mantenedorService.getB2BAgreement().then((res: any) => {
      this.b2bAgreementList = res.agreements;
      this.b2bAgreementTypeList = res.agreementType;
    })
    .catch((error: any) => {console.log(error)})
    .finally(() => { this.isLoading = false; });
  }

  clickB2B(b2bAgreement){
    this.b2bAgreementSelected = b2bAgreement;
  }

  editB2B(){
    this.isEdit = true;
  }

  cancelEditB2B(tipo){
    if(tipo == 'update'){
      this.isEdit = false;
    }else if (tipo == 'insert'){
      ($('#saveB2B') as any).modal('hide');
    }
  }

  crudB2B(accion: 'insert' | 'update'){

    const objeto = accion === 'insert' ? this.nuevoB2BAgreement : this.b2bAgreementSelected;
    if (!this.validarCamposObligatorios(objeto)) return;
    
    let dataSend = {};
    
    if(accion == 'update'){
      dataSend = this.b2bAgreementSelected;
    }else if(accion == 'insert'){
      dataSend = this.nuevoB2BAgreement;
    }
    // console.log('Acuerdo a guardar:', dataSend); // Para depurar

    this.mantenedorService.postUpdateB2BAgreement(dataSend, accion)
    .then((resp: any) => {
      const id = resp['id'];
      // console.log('Acuerdo modificado con id:', id);
      
      if (this.selectedImageFile && id) {
        // console.log('se cambio imagen');
        this.mantenedorService.uploadB2BImage(id, this.selectedImageFile)
          .then(() => {
            this.finalizarGuardado();
          })
          .catch(err => {
            console.error('Error al subir imagen:', err);
          });
      } else {
        this.finalizarGuardado();
      }
      
    })
    .catch(err => {
      console.error('Error al actualizar:', err);
    });

  }

  finalizarGuardado(): void {
    // ✅ Cierra el modal con jQuery
    Swal.fire('Guardado exitoso', '', 'success');
    ($('#visualizarB2B') as any).modal('hide');
    // ✅ Refresca la lista
    this.getB2BAgreement();
    this.isEdit = false;
  }


  onFileSelected(event: any): void {
    const file = event.target.files[0];
    const allowedTypes = ['image/jpeg', 'image/png', 'image/webp'];

    if (file) {
      if (!allowedTypes.includes(file.type)) {
        this.imageError = 'Formato no válido. Solo se permiten JPG, PNG o WEBP.';
        this.selectedImageFile = null;
        this.imagePreview = null;
        return;
      }

      const maxSizeMB = 2;
      if (file.size > maxSizeMB * 1024 * 1024) {
        this.imageError = 'La imagen no debe superar los 2 MB.';
        this.selectedImageFile = null;
        this.imagePreview = null;
        return;
      }

      this.selectedImageFile = file;
      this.imageError = null;

      const reader = new FileReader();
      reader.onload = () => {
        this.imagePreview = reader.result;
      };
      reader.readAsDataURL(file);
    }
  }

  clearSelectedImage(): void {
    this.selectedImageFile = null;
    this.imagePreview = null;
    this.imageError = null;
  }

  validarCamposObligatorios(obj: any): boolean {
    if (!obj.agre_agre_typ_id || !obj.agre_title || !obj.agre_subtitle || !obj.agre_description) {
      Swal.fire('Faltan datos obligatorios', 'Debes completar: nombre prestación, título, subtítulo y descripción.', 'warning');
      return false;
    }
    return true;
  }



}
